import { convertStringToHTMLFormattedString } from "../../../../../common-utils";
import styles from "./countdownClockWAC.module.css";
import { TitleProps } from "./types";
import DOMPurify from "dompurify";

const Title = ({ title, description }: TitleProps) => {
  return (
    <div>
      <h1
        className={`${styles.carTitle} text-center`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(convertStringToHTMLFormattedString(title)),
        }}
      />
      <div
        className="mt-4"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(convertStringToHTMLFormattedString(description)),
        }}
      />
    </div>
  );
};

export default Title;
